import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/technologies/data-visualization/page.tsx");
